import { useTranslation } from 'react-i18next';
import { useStrava } from '../hooks/useStrava.ts';

const STRAVA_ORANGE = '#FC4C02';

/**
 * Small "pull missing activities" button for embedding next to lists /
 * calendars where ride gaps are visible. Renders nothing when Strava is
 * not connected — the deeper Connect flow lives on the Profile page.
 */
export function StravaSyncButton() {
  const { t } = useTranslation();
  const { status, sync } = useStrava();

  const data = status.data;
  if (!data?.configured || !data.connected) return null;

  const job = data.last_job;
  const isSyncing = job?.status === 'running' || sync.isPending;

  return (
    <button
      onClick={() => sync.mutate()}
      disabled={isSyncing}
      className="px-3 py-1 rounded-lg text-xs font-semibold border hover:brightness-110 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed transition-all"
      style={{
        borderColor: STRAVA_ORANGE,
        color: STRAVA_ORANGE,
        backgroundColor: `${STRAVA_ORANGE}14`,
      }}
      title={t('strava.syncNow')}
    >
      {isSyncing
        ? `${t('strava.syncing')}… ${job?.activities_fetched ?? 0}`
        : t('strava.syncNow')}
    </button>
  );
}
